import { mixins } from 'vue-class-component';
import { Component } from 'vue-property-decorator';
import { PAGE_NAMES } from '@/constants';
import { formatDateToLocalDateTime } from '@/helpers';
import { ProjectRequestDTO, SelectionOptions } from '@/models';
import { createProject } from '@/services';
import ProjectInformationMixin from '@/components/pages/project-evaluation/project-information/project-information-mixin';
import ConfirmationDialog from '@/components/common/confirmation-dialog/ConfirmationDialog.vue';
import EvaluationProcessBar from '@/components/pages/project-evaluation/evaluation-process-bar/EvaluationProcessBar.vue';
import InlineLoader from '@/components/common/loader/inline-loader/InlineLoader.vue';
import PageLoader from '@/components/common/loader/page-loader/PageLoader.vue';
import ProjectEvaluationHeader from '@/components/common/project-evaluation-header/ProjectEvaluationHeader.vue';
import ProjectInformationForm from '@/components/pages/project-evaluation/project-information/project-information-form/ProjectInformationForm.vue';

@Component({
  components: {
    ConfirmationDialog,
    EvaluationProcessBar,
    InlineLoader,
    PageLoader,
    ProjectEvaluationHeader,
    ProjectInformationForm
  }
})
export default class ProjectCreation extends mixins(ProjectInformationMixin) {
  private pageLoaderShown = false;
  private isSaving = false;
  private userOptions = [] as SelectionOptions;
  private dirtyCheckDialogShown = false;

  async createProject(): Promise<void> {
    const isDataValid = this.validateProjectData();
    if (isDataValid) {
      this.isSaving = true;
      const projectData = {
        ...this.projectFormData,
        startDate: formatDateToLocalDateTime(this.projectFormData.startDate),
        endDate: formatDateToLocalDateTime(this.projectFormData.endDate)
      };
      const responseProject = await createProject(projectData);
      this.isSaving = false;

      await this.$router.push({
        name: PAGE_NAMES.PROJECT_EVALUATION,
        params: { id: '' + responseProject.data.id }
      });
    }
  }

  async cancel(): Promise<void> {
    if (this.isDirty()) {
      this.dirtyCheckDialogShown = true;
    } else {
      this.onDirtyCheckDialogConfirmed();
    }
  }

  isDirty(): boolean {
    const { projectFormData } = this;
    const keys = Object.keys(projectFormData) as Array<keyof ProjectRequestDTO>;
    return keys.some(key => projectFormData[key]);
  }

  onDirtyCheckDialogConfirmed(): void {
    this.$router.push({ name: PAGE_NAMES.PROJECT_LIST });
  }

  async created(): Promise<void> {
    this.pageLoaderShown = true;
    await this.$store.dispatch('user/asyncFetchUsers');
    this.userOptions = this.buildUserOptions();
    this.projectFormData = await this.buildProjectData();
    this.pageLoaderShown = false;
  }
}
